module.exports = __webpack_public_path__ + "static/media/14.69ec1c0c.png";